import { Card, CardContent } from '@/components/ui/card'
import { Car, Bike, ShieldCheck, Wrench } from 'lucide-react'
import { useI18n } from '@/store/I18nContext'

export function YardMapPreview() {
  const { t } = useI18n()
  const slots = [
    { num: '01', status: 'occupied', type: 'car' },
    { num: '02', status: 'free', type: 'car' },
    { num: '03', status: 'reserved', type: 'car' },
    { num: '04', status: 'occupied', type: 'bike' },
    { num: '05', status: 'occupied', type: 'car' },
    { num: '06', status: 'free', type: 'car' },
    { num: '07', status: 'maintenance', type: 'car' },
    { num: '08', status: 'free', type: 'car' },
  ]

  return (
    <section className="py-20 bg-muted/30" id="operacao">
      <div className="container mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6 animate-fade-in-up">
          <div className="inline-block px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-bold tracking-wider uppercase mb-2">
            {t('yard.badge')}
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter leading-tight">
            {t('yard.title')}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-medium">
            {t('yard.subtitle')}
          </p>
          <ul className="space-y-3 pt-4">
            <li className="flex items-center gap-3 text-emerald-700 font-semibold">
              <span className="w-3 h-3 rounded-full bg-emerald-500 shadow-[0_0_10px_rgba(16,185,129,0.5)]"></span>{' '}
              {t('yard.free')}
            </li>
            <li className="flex items-center gap-3 text-red-700 font-semibold">
              <span className="w-3 h-3 rounded-full bg-red-500 shadow-[0_0_10px_rgba(239,68,68,0.5)]"></span>{' '}
              {t('yard.occupied')}
            </li>
            <li className="flex items-center gap-3 text-blue-700 font-semibold">
              <span className="w-3 h-3 rounded-full bg-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.5)]"></span>{' '}
              {t('yard.reserved')}
            </li>
            <li className="flex items-center gap-3 text-yellow-700 font-semibold">
              <span className="w-3 h-3 rounded-full bg-yellow-500 shadow-[0_0_10px_rgba(234,179,8,0.5)]"></span>{' '}
              {t('yard.maintenance')}
            </li>
          </ul>
        </div>

        <div className="animate-fade-in">
          <Card className="shadow-2xl border-border bg-card overflow-hidden">
            <CardContent className="p-6">
              <div className="grid grid-cols-4 gap-3">
                {slots.map((slot) => (
                  <div
                    key={slot.num}
                    className={`relative flex flex-col items-center justify-center p-3 rounded-xl border-2 transition-all h-24 shadow-sm ${
                      slot.status === 'free'
                        ? 'bg-emerald-50 border-emerald-300 text-emerald-800'
                        : slot.status === 'occupied'
                          ? 'bg-red-50 border-red-300 text-red-800'
                          : slot.status === 'reserved'
                            ? 'bg-blue-50 border-blue-300 text-blue-800'
                            : 'bg-yellow-50 border-yellow-300 text-yellow-800'
                    }`}
                  >
                    <span className="absolute top-1 left-2 text-xs font-bold opacity-60">
                      {slot.num}
                    </span>
                    {slot.type === 'bike' ? (
                      <Bike className="h-6 w-6 mb-1 opacity-70" />
                    ) : (
                      <Car className="h-6 w-6 mb-1 opacity-70" />
                    )}
                    {slot.status === 'occupied' && (
                      <span className="font-extrabold text-xs tracking-tight">
                        ABC-1234
                      </span>
                    )}
                    {slot.status === 'reserved' && (
                      <ShieldCheck className="h-4 w-4" />
                    )}
                    {slot.status === 'maintenance' && (
                      <Wrench className="h-4 w-4" />
                    )}
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  )
}
